<template>
  <div class="grid-container full">
    <div class="grid-x page-contents-8" >
      <div class=" small-12 cell text-center">
        <h2>Trusted by 125+ top employers</h2>
      </div>
    </div>
    <div id="logosLarge">
      <div class="grid-x align-justify align-middle  page-contents-8">
        <div class="small-2 cell text-center">
            <img
              style="max-height: 30px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/4-new-square.png" alt="4 New Square"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 40px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/addleshaw.png" alt="Addleshaw Goddard"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 15px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/a-o-shearman.png" alt="A & O Shearman.png"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 17px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/Allens.png" alt="Allens"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
            <img
              style="max-height: 49px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/anthony-collins.png" alt="Anthony Collins"/>

        </div>
        <div class="auto cell text-center">
            <img
              style="height: 30px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Ashfords.png" alt="Ashfords"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="height: 27px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Ashurst.png" alt="Ashurst"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 24px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BainCompany.png" alt="Bain Company"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="height: 35px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/BakerMcKenzie.png" alt="Baker McKenzie"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
            <img
              style="max-height: 40px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BCG.png" alt="BCG"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 65px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/bevan-brittan.png" alt="Bevan Brittan"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 24px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BirdAndBird.png" alt="Barclays"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 18px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BlackRock.png" alt="Black Rock"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 55px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/blake-morgan.png" alt="Blake Morgan"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 70px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/bp.png" alt="BP"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle page-contents-8 large-logo-row">
        <div class="auto cell text-left">
          <img
            style="max-height: 22px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/brabners.png" alt="Branbners"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 25px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/bristows.png" alt="BP"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 50px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BritishLand.png" alt="British Land"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 64px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/brodies.png" alt="Brodies Land"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 33px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/browne-jacobson.png" alt="Browne Jacobson"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="height: 37px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BLP.png" alt="BLP"/>
        </div>
      </div>


      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
            <img
              style="height: 54px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/BurgesSalmon.png" alt="Bain"/>
        </div>
        <div class="auto cell text-left">
            <img
              style="height: 40px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/burness-paull.png" alt="Burness Paull"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="height: 60px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/canary-wharf-group.png" alt="Canary Wharf Group"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="height: 12px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/carpmaels-ransford.png" alt="Carpmaels Ransford"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 65px; "
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/carter-jonas.png" alt="Carter Jonas"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 55px; "
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/crs.png" alt="Charles Russell Speechlys"/>
        </div>

        <div class="auto cell text-right">
          <img
            style="max-height: 38px; "
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/chatham-house.png" alt="Chatham House"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
          <img
            style="max-height: 35px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/ClaytonUtz.png" alt="Clayton Utz"/>
        </div>
        <div class="auto cell text-left">
          <img
            style="max-height: 17px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/cleary-gottlieb.png" alt="Cleary Gottlieb"/>
        </div>
        <div class="small-2 cell text-center">
          <img
            style="max-height: 43px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/CliffordChance.png" alt="Clifford Chance"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 22px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/ClydeCo.png" alt="Clyde Co."/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 45px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/cms.png" alt="CMS"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 57px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/colliers-international.png" alt="Colliers International"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 38px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Cooley.png" alt="Cooley"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
          <img
            style="max-height: 36px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/CushmanAndWakefield.png" alt="Cushman & Wakefield"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 38px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/dechert.png" alt="Dechert"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 35px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/dentons.png" alt="Dentons"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 50px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/DLAPiper.png" alt="DLA Piper"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 33px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/efficio.png" alt="Efficio"/>
        </div>
        <div class="auto cell text-right">
        <img
          style="max-height: 31px;"
          class="clientImg"
          src="@/assets/img/logos/home-page-logos/Eversheds.png" alt="Eversheds"/>
      </div>
      </div>

      <div class="grid-x align-justify align-middle page-contents-8 large-logo-row">
        <div class="auto cell text-left">
            <img
              style="max-height: 52px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/ey.png" alt="EY"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 23px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/FarrerCo.png" alt="Farrer Co."/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 30px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/fladgate.png" alt="Fladgate"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 34px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/FootAntsey.png" alt="FootAntsey"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 32px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/forsters.png" alt="FootAntsey"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 32px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Freeths.png" alt="Freeths"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 44px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/Freshfields2.png" alt="Freshfields"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-1 cell text-left">
            <img
              style="max-height: 65px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/goodwin.png" alt="Goodwin"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 34px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/gowling.png" alt="Gowling"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 31px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/harbottle-lewis.png" alt="Harbottle Lewis"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 24px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/hausfeld.png" alt="Hausfeld"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 51px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/HSF.png" alt="Herbert Smith Freehills"/>
        </div>
        <div class="small-1 cell text-right">
          <img
            style="max-height: 50px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/HFW.png" alt="Holman Fenwick Willan"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-1 cell text-left">
            <img
              style="max-height: 60px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/HoganLovells.png" alt="Hogan Lovells"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 50px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/howard-kennedy.png" alt="Howard Kennedy"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 43px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/howes-percival.png" alt="Howes Percival"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 38px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/hsbc.png" alt="HSBC"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 16px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/inner-temple.png" alt="The Inner Temple"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 39px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/JLL.png" alt="JLL"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle page-contents-8 large-logo-row">
        <div class="small-1 cell text-left">
          <img
            style="max-height: 46px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/JonesDay.png" alt="Jones Day"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 62px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/katten.png" alt="Jones Day"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 22px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/kl-gates.png" alt="K&L Gates"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 37px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/kennedys.png" alt="Kennedys"/>
        </div>
        <div class="small-2 cell text-center">
            <img
              style="max-height: 24px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/kilburn-strode.png" alt="Kilburn Strode"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 30px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/kingsleynapley.png" alt="Kingsley Napley"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
          <img
            style="max-height: 17px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/kirkland-and-ellis.png" alt="Kirkland & Ellis"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 41px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/KnightFrank.png" alt="Knight Frank"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 15px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/LathamWatkins.png" alt="Latham & Watkins"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 47px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/law-society-scotland.png" alt="Law Society Scotland"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 28px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/LeighDay.png" alt="Leigh Day"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
          <img
            style="max-height: 40px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/LewisSilkin.png" alt="Lewis Silkin"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 35px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/lifearc.png" alt="Lifearc"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 23px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Linklaters.png" alt="Linklaters"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 17px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Macfarlanes.png" alt="Macfarlanes"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 30px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/maven.png" alt="Maven"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle page-contents-8 large-logo-row">
        <div class="auto cell text-left">
            <img
              style="max-height: 45px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/mazars.png" alt="Mazars"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 45px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/mewburn-ellis.png" alt="Mewburn Ellis"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 25px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/michelmores.png" alt="Michelmores"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 25px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Milbank.png" alt="Milbank"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 17px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/MillsReeve.png" alt="MillsReeve.png"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 22px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/mishcon-de-reya.png" alt="Mishcon de Reya"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-2 cell text-left">
            <img
              style="max-height: 25px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/MorganStanley.png" alt="Morgan Stanley"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height:50px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/NationalAuditOffice.png" alt="National Audit Office"/>
        </div>
        <div class="small-2 cell text-center" style="padding-right:3px;">
            <img
              style="max-height: 33px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/NortonRoseFulbright.png" alt="NortonRoseFulbright"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 40px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/ocandc.png" alt="OC & C"/>
        </div>
        <div class="small-2 cell text-center"  style="padding-left:3px;">
            <img
              style="max-height: 16px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/OliverWyman.png" alt="Oliver Wyman"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-1 cell text-left">
            <img
              style="max-height: 46px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Orrick.png" alt="Orrick"/>
        </div>
        <div class="small-1 cell text-left">
            <img
              style="max-height: 52px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/OsborneClarke.png" alt="OsborneClarke"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 23px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/payne-hicks-beach.png" alt="Payne Hicks Beach"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 48px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/pmc.png" alt="PMC"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 56px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/PinsentMasons.png" alt="PinsentMasons"/>
        </div>
        <div class="small-1 cell text-center">
          <img
            style="max-height: 60px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/Prime.png" alt="Prime"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 30px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/quadrant-chambers.png" alt="Quadrant Chambers"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-center">
            <img
              style="max-height: 26px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/radcliffe-chambers.png" alt="Radcliffe Chambers"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 26px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/reed-smith.png" alt="Radcliffe Chambers"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 32px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/RopesGray.png" alt="RopesGray"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 60px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/RPC.png" alt="RPC"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 37px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/russell-cooke.png" alt="Russell Cooke"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 36px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/saffery-champness.png" alt="Saffery Champness"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-1 cell text-leftr">
            <img
              style="max-height: 60px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Savills.png" alt="Savills"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 65px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/serle-court.jpg" alt="Serle Court"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 60px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/shepherd-wedderburn.png" alt="Shepherd Wedderburn"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 22px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/Sidley.png" alt="Sidley"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 20px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/simmonsandsimmons.png" alt="Simmons & Simmons"/>
        </div>
        <div class="small-2 cell text-right">
          <img
            style="max-height: 13px;"
            class="clientImg text-center"
            src="@/assets/img/logos/home-page-logos/SlaughterAndMay.png" alt="Slaughter And May"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
            <img
              style="max-height: 36px;"
              class="clientImg text-center"
              src="@/assets/img/logos/home-page-logos/squire-patton-boggs.png" alt="Squire Patton Boggs"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 43px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/StephensonHarwood.png" alt="Stephenson Harwood"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 21px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/stewarts.png" alt="Stewarts"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 59px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/StJamesPlace.png" alt="Saint James Place Wealth Managment"/>
        </div>
        <div class="small-2 cell text-right">
          <img
            style="max-height: 27px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/taylorwessing.png" alt="Taylor Wessing"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-2 cell text-left">
          <img
            style="max-height: 35px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/thorntons.png" alt="Thorntons"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 55px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/tlt.png" alt="TLT"/>
        </div>
        <div class="auto cell text-left">
            <img
              style="max-height: 38px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/TraversSmith.png" alt="Travers Smith"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 48px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/trowers-hamlins.png" alt="Trowers Hamlins"/>
        </div>
        <div class="auto cell text-right">
            <img
              style="max-height: 42px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/ttp.png" alt="TTP"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="small-1 cell text-left">
          <img
            style="max-height: 64px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/20-essex-street.png" alt="Twenty Essex Street"/>
        </div>
        <div class="small-1 cell text-center">
          <img
            style="max-height: 87px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/supreme-court.png" alt="The Supreme Court"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 45px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/walker-morris.png" alt="Walker Morris"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-height: 39px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/wfw.png" alt="Weil"/>
        </div>
        <div class="auto cell text-center">
            <img
              style="max-width: 140px;"
              class="clientImg"
              src="@/assets/img/logos/home-page-logos/WedlakeBell.png" alt="Wedlake Bell"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-width: 65px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/Weil.png" alt="Weil"/>
        </div>
      </div>

      <div class="grid-x align-justify align-middle  page-contents-8 large-logo-row">
        <div class="auto cell text-left">
          <img
            style="max-height: 14px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/White&Case.png" alt="White & Case"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 31px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/wiggin.png" alt="Wiggin"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 28px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/wilberforce.png" alt="Wilberforce Chambers"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 38px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/willkie.png" alt="Willkie"/>
        </div>
        <div class="auto cell text-center">
          <img
            style="max-height: 35px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/Withersworldwide.png" alt="Withers Worldwide"/>
        </div>
        <div class="auto cell text-right">
          <img
            style="max-height: 50px;"
            class="clientImg"
            src="@/assets/img/logos/home-page-logos/womble-bond-dickinson.png" alt="Womble Bond Dickinson"/>
        </div>
      </div>
    </div>

    <!-- *****************MOBILE LOGOS START***************** -->

    <div id="logosSmall">
      <div v-if="paneToShow === 'ac'">
        <div class="grid-x carouselPane align-justify align-middle page-contents-8">
          <div class="small-12 cell">

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 65px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/4-new-square.png" alt="4 New Square"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 40px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/addleshaw.png" alt="Addleshaw Goddard"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 15px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/a-o-shearman.png" alt="A & O Shearman.png"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 17px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Allens.png" alt="Allens"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 49px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/anthony-collins.png" alt="Anthony Collins"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="height: 30px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Ashfords.png" alt="Ashfords"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="height: 27px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Ashurst.png" alt="Ashurst"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 24px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BainCompany.png" alt="Bain Company"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="height: 35px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BakerMcKenzie.png" alt="Baker McKenzie"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 40px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BCG.png" alt="BCG"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 65px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/bevan-brittan.png" alt="Bevan Brittan"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 24px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BirdAndBird.png" alt="Barclays"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 55px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/blake-morgan.png" alt="Blake Morgan"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 70px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/bp.png" alt="BP"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 22px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/brabners.png" alt="Brabners"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 25px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/bristows.png" alt="BP"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 50px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BritishLand.png" alt="British Land"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 64px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/brodies.png" alt="Brodies Land"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 33px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/browne-jacobson.png" alt="Browne Jacobson"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="height: 37px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BLP.png" alt="BLP"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="height: 54px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/BurgesSalmon.png" alt="Bain"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="height: 40px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/burness-paull.png" alt="Burness Paull"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="height: 60px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/canary-wharf-group.png" alt="Canary Wharf Group"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="height: 12px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/carpmaels-ransford.png" alt="Carpmaels Ransford"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 65px; "
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/carter-jonas.png" alt="Carter Jonas"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 55px; "
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/crs.png" alt="Charles Russell Speechlys"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 38px; "
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/chatham-house.png" alt="Chatham House"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 35px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/ClaytonUtz.png" alt="Clayton Utz"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 17px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/cleary-gottlieb.png" alt="Cleary Gottlieb"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 43px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/CliffordChance.png" alt="Clifford Chance"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 22px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/ClydeCo.png" alt="Clyde Co."/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 45px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/cms.png" alt="CMS"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 57px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/colliers-international.png" alt="Colliers International"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 38px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Cooley.png" alt="Cooley"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 36px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/CushmanAndWakefield.png" alt="Cushman & Wakefield"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="paneToShow === 'dk'">
        <div class="grid-x carouselPane align-justify align-middle page-contents-8">
          <div class="small-12 cell">

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 38px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/dechert.png" alt="Dechert"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 35px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/dentons.png" alt="Dentons"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 50px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/DLAPiper.png" alt="DLA Piper"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 33px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/efficio.png" alt="Efficio"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 31px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Eversheds.png" alt="Eversheds"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 52px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/ey.png" alt="EY"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 23px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/FarrerCo.png" alt="Farrer Co."/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 30px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/fladgate.png" alt="Fladgate"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 36px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/FootAntsey.png" alt="FootAntsey"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 32px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/forsters.png" alt="FootAntsey"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 32px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Freeths.png" alt="Freeths"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 32px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Freshfields2.png" alt="Freshfields"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 65px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/goodwin.png" alt="Goodwin"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 34px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/gowling.png" alt="Gowling"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height:30px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/harbottle-lewis.png" alt="Harbottle & Lewis"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 21px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/hausfeld.png" alt="Hausfeld"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 51px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/HSF.png" alt="Herbert Smith Freehills"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 50px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/HFW.png" alt="Holman Fenwick Willan"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 60px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/HoganLovells.png" alt="Hogan Lovells"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 43px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/howard-kennedy.png" alt="Howard Kennedy"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 43px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/howes-percival.png" alt="Howes Percival"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 38px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/hsbc.png" alt="HSBC"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 16px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/inner-temple.png" alt="The Inner Temple"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 39px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/JLL.png" alt="JLL"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 46px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/JonesDay.png" alt="Jones Day"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 62px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/katten.png" alt="Jones Day"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 22px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/kl-gates.png" alt="K&L Gates"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 37px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/kennedys.png" alt="Kennedys"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 24px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/kilburn-strode.png" alt="Kilburn Strode"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 30px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/kingsleynapley.png" alt="Kingsley Napley"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 18px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/kirkland-and-ellis.png" alt="Kirkland & Ellis"/>
              </div>
            <div class="auto cell text-center">
              <img
                style="max-height: 41px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/KnightFrank.png" alt="Knight Frank"/>
            </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="paneToShow === 'lr'">
        <div class="grid-x carouselPane align-justify align-middle page-contents-8">
          <div class="small-12 cell">

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 15px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/LathamWatkins.png" alt="Latham & Watkins"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 47px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/law-society-scotland.png" alt="Law Society Scotland"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 28px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/LeighDay.png" alt="Leigh Day"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 40px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/LewisSilkin.png" alt="Lewis Silkin"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 35px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/lifearc.png" alt="Lifearc"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 23px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Linklaters.png" alt="Linklaters"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 17px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Macfarlanes.png" alt="Macfarlanes"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 30px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/maven.png" alt="Maven"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 45px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/mazars.png" alt="Mazars"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 45px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/mewburn-ellis.png" alt="Mewburn Ellis"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 24px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/michelmores.png" alt="Michelmores"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 25px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Milbank.png" alt="Milbank"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 18px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/MillsReeve.png" alt="MillsReeve.png"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 27px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/mishcon-de-reya.png" alt="Mishcon de Reya"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 25px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/MorganStanley.png" alt="Morgan Stanley"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height:50px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/NationalAuditOffice.png" alt="National Audit Office"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 33px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/NortonRoseFulbright.png" alt="NortonRoseFulbright"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 40px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/ocandc.png" alt="OC & C"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center"  style="padding-left:3px;">
                <img
                  style="max-height: 16px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/OliverWyman.png" alt="Oliver Wyman"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 46px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Orrick.png" alt="Orrick"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 52px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/OsborneClarke.png" alt="OsborneClarke"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 23px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/payne-hicks-beach.png" alt="Payne Hicks Beach"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 48px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/pmc.png" alt="PMC"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 56px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/PinsentMasons.png" alt="PinsentMasons"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 60px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Prime.png" alt="Prime"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 30px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/quadrant-chambers.png" alt="Quadrant Chambers"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 26px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/radcliffe-chambers.png" alt="Radcliffe Chambers"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 27px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/reed-smith.png" alt="RopesGray"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 32px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/RopesGray.png" alt="RopesGray"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 60px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/RPC.png" alt="RPC"/>
              </div>
              </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 37px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/russell-cooke.png" alt="Russell Cooke"/>
              </div>
              </div>
            </div>
        </div>
      </div>

      <div v-if="paneToShow === 'sz'">
        <div class="grid-x carouselPane align-justify align-middle page-contents-8">
          <div class="small-12 cell">

            <div class="grid-x align-justify align-middle icon-row">
            <div class="auto cell text-center">
              <img
                style="max-height: 36px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/saffery-champness.png" alt="Saffery Champness"/>
            </div>
            <div class="auto cell text-center">
              <img
                style="max-height: 60px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/Savills.png" alt="Savills"/>
            </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
            <div class="auto cell text-center">
              <img
                style="max-height: 65px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/serle-court.jpg" alt="Serle Court"/>
            </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 60px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/shepherd-wedderburn.png" alt="Shepherd Wedderburn"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
            <div class="auto cell text-center">
              <img
                style="max-height: 22px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/Sidley.png" alt="Sidley"/>
            </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 20px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/simmonsandsimmons.png" alt="Simmons & Simmons"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
            <div class="auto cell text-center">
              <img
                style="max-height: 13px;"
                class="clientImg text-center"
                src="@/assets/img/logos/home-page-logos/SlaughterAndMay.png" alt="Slaughter And May"/>
            </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 36px;"
                  class="clientImg text-center"
                  src="@/assets/img/logos/home-page-logos/squire-patton-boggs.png" alt="Squire Patton Boggs"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
            <div class="auto cell text-center">
              <img
                style="max-height: 43px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/StephensonHarwood.png" alt="Stephenson Harwood"/>
            </div>
            <div class="auto cell text-center">
              <img
                style="max-height: 56px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/StJamesPlace.png" alt="Saint James Place Wealth Managment"/>
            </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
            <div class="auto cell text-center">
              <img
                style="max-height: 27px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/taylorwessing.png" alt="Taylor Wessing"/>
            </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 35px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/thorntons.png" alt="Thorntons"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
              <img
                style="max-height: 55px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/tlt.png" alt="TLT"/>
            </div>
            <div class="auto cell text-center">
              <img
                style="max-height: 38px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/TraversSmith.png" alt="Travers Smith"/>
            </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 48px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/trowers-hamlins.png" alt="Trowers Hamlins"/>
              </div>
            <div class="auto cell text-center">
              <img
                style="max-height: 42px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/ttp.png" alt="TTP"/>
            </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 64px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/20-essex-street.png" alt="Twenty Essex Street"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 87px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/supreme-court.png" alt="The Supreme Court"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 45px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/walker-morris.png" alt="Walker Morris"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 39px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/wfw.png" alt="Weil"/>
            </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-width: 140px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/WedlakeBell.png" alt="Wedlake Bell"/>
              </div>
            <div class="auto cell text-center">
              <img
                style="max-width: 65px;"
                class="clientImg"
                src="@/assets/img/logos/home-page-logos/Weil.png" alt="Weil"/>
            </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 14px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/White&Case.png" alt="White & Case"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 31px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/wiggin.png" alt="Wiggin"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 28px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/wilberforce.png" alt="White & Case"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 40px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/willkie.png" alt="Willkie"/>
              </div>
            </div>

            <div class="grid-x align-justify align-middle icon-row">
              <div class="auto cell text-center">
                <img
                  style="max-height: 35px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/Withersworldwide.png" alt="Withers Worldwide"/>
              </div>
              <div class="auto cell text-center">
                <img
                  style="max-height: 55px;"
                  class="clientImg"
                  src="@/assets/img/logos/home-page-logos/womble-bond-dickinson.png" alt="Womble Bond Dickinson"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-x show-for-small-only carouselCont page-contents-8">
        <div class="auto cell text-center carouselLinkCont">
          <a href="#" @click.prevent="changPane('ac')" class="carouselLink"
             :class="{selected: paneToShow === 'ac'}">A-C
          </a>
        </div>
        <div class="auto cell text-center carouselLinkCont">
          <a href="#" @click.prevent="changPane('dk')" class="carouselLink"
             :class="{selected: paneToShow === 'dk'}">D-K
          </a>
        </div>
        <div class="auto cell text-center carouselLinkCont">
          <a href="#" @click.prevent="changPane('lr')" class="carouselLink"
             :class="{selected: paneToShow === 'lr'}">L-R
          </a>
        </div>
        <div class="auto cell text-center carouselLinkCont">
          <a href="#" @click.prevent="changPane('sz')" class="carouselLink"
             :class="{selected: paneToShow === 'sz'}">S-Z
          </a>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'RareClientsLogos',
  data() {
    return {
      paneToShow: 'ac',
    };
  },
  methods: {
    changPane(newPane) {
      this.paneToShow = newPane;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "src/css/global.scss";

.carouselLinkCont {
  padding-bottom: 19px;
}

.carouselLinkCont:last-child {
  padding-right: 0;
}

.icon-row {
  margin-bottom: 27px;
}

.large-logo-row {
  margin-top: 40px;
}

a.carouselLink {
  color: #b8bec2;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 4px;
  padding: 0;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
}

.selected {
  color: $main-text !important;
  border-bottom: 4px solid $green-highlight;
  font-weight: bold !important;
}

#logosLarge {
  margin-bottom: 50px;
}

#logosSmall {
  margin-bottom: 50px;
}


.auto, .small-1, small-2, small-3 {
  padding: 0;
}

.clientImg {
  max-width: 100%;
}

h2 {
  color: $main-text;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
}

@media only screen and (max-width: 640px)  {
  #logosLarge {
    display: none;
  }
  #logosSmall {
    display: block;
  }

  h2 {
    font-size: 28px;
    line-height: 1.29;
    letter-spacing: 0.8px;
    margin-bottom: 24px;
    margin-top: 55px;
  }
}

@media only screen and (min-width: 641px)  {
  #logosLarge {
    display: block;
  }
  #logosSmall {
    display: none;
  }


  h2 {
    font-size: 56px;
    line-height: 1.29;
    letter-spacing: 0.8px;
    margin-bottom: 60px;
    margin-top: 75px;
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/components/RareHomeClientsLogos.vue